const ClosePromoIcon = () => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_1448_829)">
			<path
				d="M10.5 3.5L3.5 10.5"
				stroke="#FF0000"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.5 3.5L10.5 10.5"
				stroke="#FF0000"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1448_829">
				<rect
					width="14"
					height="14"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default ClosePromoIcon;
